import EntityModel from '@/common/models/entity-model';

export default class GatewayAccountDowntimeModel extends EntityModel {
    hydrate({
        id = null,
        status = null,
        startTime = null,
        endTime = null,
    } = {}) {
        this.id = id;
        this.status = status;
        this.startTime = startTime;
        this.endTime = endTime;
    }

    getPayload() {
        return {
            startTime: this.startTime,
            endTime: this.endTime,
        };
    }
}
